import { render, staticRenderFns } from "./ComparativoDados.vue?vue&type=template&id=7d685d4c"
import script from "./ComparativoDados.vue?vue&type=script&lang=js"
export * from "./ComparativoDados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports